import { AppPlatform, Integration, IntegrationType, MobileApp } from 'modules/mobileApps/types';
import { FC, PropsWithChildren, useMemo, useState } from 'react';
import { IntegrationMetadataContext } from './IntegrationMetadataContext';
import { IntegrationOperationType } from './types';

export const IntegrationMetadataProvider: FC<PropsWithChildren> = ({ children }) => {
  const [appDetails, setAppDetails] = useState<MobileApp>();
  const [apps, setApps] = useState<MobileApp[]>([]);
  const [assignedIntegrations, setAssignedIntegrations] = useState<IntegrationType>({});
  const [operationType, setOperationType] = useState(IntegrationOperationType.CREATE);
  const [selectedIntegration, setSelectedIntegration] = useState<Integration>();

  const mobileApps = useMemo(
    () =>
      apps.filter(
        ({ platform }) => platform === AppPlatform.ANDROID || platform === AppPlatform.IOS,
      ),
    [apps],
  );

  const value = {
    appDetails,
    apps,
    assignedIntegrations,
    mobileApps,
    operationType,
    selectedIntegration,

    setAppDetails,
    setApps,
    setAssignedIntegrations,
    setOperationType,
    setSelectedIntegration,
  };

  return (
    <IntegrationMetadataContext.Provider value={value}>
      {children}
    </IntegrationMetadataContext.Provider>
  );
};
